/**
 * Montagem da foto enviada ao backend (`POST /api/planilha-legado/fotos`):
 * as LINHAs no formato exato do contrato e a PROJECAO do dia, para que a
 * aba Precisão possa, semanas depois, comparar o previsto com o real.
 */

export const VERSAO_MODELO_PROJECAO = 1;

/** Campos da LINHA, na ordem do contrato (especificação 1.4). */
const CAMPOS_DA_LINHA = [
  "identidade",
  "chave",
  "pedido",
  "ambiente",
  "cliente",
  "linha_planilha",
  "data_venda",
  "obra_futura",
  "entrega_contrato",
  "aprovacao",
  "data_reprogramada",
  "corte",
  "marcenaria_inicio",
  "marcenaria_termino",
  "carregamento",
  "lote",
  "marceneiro",
  "termino",
  "ajuste_termino",
  "servico",
  "cancelado",
  "erros",
];

function arredondar(valor, casas) {
  const fator = 10 ** casas;
  return Math.round(valor * fator) / fator;
}

/**
 * LINHAs para a foto: só as que têm identidade (sem pedido ou ambiente não
 * há como reencontrar o ambiente na próxima foto) e só os campos do
 * contrato — `erros_texto` e os campos de uso local ficam de fora.
 */
export function linhasParaFoto(linhas) {
  return (linhas || [])
    .filter((linha) => linha.identidade)
    .map((linha) => ({
      ...Object.fromEntries(CAMPOS_DA_LINHA.map((campo) => [campo, linha[campo] ?? null])),
      obra_futura: Boolean(linha.obra_futura),
      servico: Boolean(linha.servico),
      cancelado: Boolean(linha.cancelado),
      erros: linha.erros || [],
    }));
}

/**
 * PROJECAO = `{versao_modelo, hoje, fila, ritmo_por_du, du_previstos,
 * cobertura}`; `null` quando não há ritmo (nada a medir depois).
 */
export function montarProjecaoParaFoto({ hoje, fila, ritmo } = {}) {
  if (!ritmo?.ritmo) return null;
  return {
    versao_modelo: VERSAO_MODELO_PROJECAO,
    hoje,
    fila,
    ritmo_por_du: arredondar(ritmo.ritmo, 4),
    du_previstos: arredondar(fila / ritmo.ritmo, 2),
    cobertura: arredondar(ritmo.cobertura, 4),
  };
}
